import {
    SET_PATIENTS,
    SET_EMAIL_TEMPLATE,
    SET_PROMPT,
    SET_CUSTOM_EMAIL_TEMPLATE,
    SET_PATIENT_INVITE_LOGS,

} from "./types";

const initialState = {
    patients: {
        list: null,
        count: 0,
    },

    emailTemplates: {
        list: [],
        count: 0,
    },

    customEmailTemplates: {
        list: [],
        count: 0,
    },

    patientInviteLogs: {
        list: [],
        count: 0,
    },

    emailPrompt: null,
    patientSummaryPrompt: null,
    emailFilterPrompt: null,


};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_PATIENTS:
            return {
                ...state,
                patients: action.data
            }

        case SET_EMAIL_TEMPLATE:
            return {
                ...state,
                emailTemplates: {
                    list: action.data.list,
                    count: action.data.count,
                }
            }

        case SET_CUSTOM_EMAIL_TEMPLATE:
            return {
                ...state,
                customEmailTemplates: {
                    list: action.data.list,
                    count: action.data.count,
                }
            }

        case SET_PROMPT:
            return {
                ...state,
                [action.data.key || action.data.name]: action.data.prompt,
            }

        case SET_PATIENT_INVITE_LOGS:
            return {
                ...state,
                patientInviteLogs: action.data
            }

        default:
            return state;
    }
}